function o(e) {
  return e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z])([A-Z][a-z])/g, "$1-$2").replace(/_/g, "-").replace(/([A-Z]+)/g, (a) => a.toLowerCase()).replace(/--+/g, "-").replace(/^-+|-+$/g, "").toLowerCase();
}
function p(e) {
  return e.replace(/-([a-z])/g, (a, r) => r.toUpperCase());
}
export {
  p as toCamelCase,
  o as toKebabCase
};
//# sourceMappingURL=naming.js.map
